import { render, staticRenderFns } from "./jd-kra.vue?vue&type=template&id=43980e06&"
import script from "./jd-kra.vue?vue&type=script&lang=js&"
export * from "./jd-kra.vue?vue&type=script&lang=js&"
import style0 from "./jd-kra.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports